/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 *
 * Learn more in https://angular.dev/tools/cli/environments
 */

/***************************************************************************************************
 * Zone JS is required by Angular itself.
 */
import '@angular/localize/init';
import 'es-module-shims';

/***************************************************************************************************
 * APPLICATION IMPORTS
 */

if (typeof (window as any).global === 'undefined') {
  (window as any).global = window;
}
